import React from "react";
import { NavLink } from "react-router-dom";

const Navbar = () => (
  <nav className="navbar navbar-expand-lg navbar-dark bg-dark">
    <a className="navbar-brand" href="/">
      Spawner
    </a>
    <button
      className="navbar-toggler"
      type="button"
      data-toggle="collapse"
      data-target="#navbarSupportedContent"
      aria-controls="navbarSupportedContent"
      aria-expanded="false"
      aria-label="Toggle navigation"
    >
      <span className="navbar-toggler-icon"></span>
    </button>

    <div className="collapse navbar-collapse" id="navbarSupportedContent">
      <ul className="navbar-nav mr-auto">
        <li className="nav-item active">
          <span className="nav-link">
            <NavLink activeClassName="active" to="/docs">
              Docs
            </NavLink>
          </span>
        </li>
        <li className="nav-item">
          <span className="nav-link">
            <NavLink to="/pricing">Pricing</NavLink>
          </span>
        </li>
        <li className="nav-item">
          <span className="nav-link">
            <NavLink to="/api">API</NavLink>
          </span>
        </li>
        <li className="nav-item">
          <span className="nav-link">
            <NavLink to="/submit">Submit Endpoint</NavLink>
          </span>
        </li>
      </ul>
      <ul className="navbar-nav">
        <li className="nav-item align-self-end">
          <span className="nav-link">
            <NavLink activeClassName="active" to="/login">
              Login
            </NavLink>
          </span>
        </li>
        <li className="nav-item">
          <span className="nav-link" id="cta">
            <NavLink to="/signup">
              <button className="btn btn-red">Sign Up</button>
            </NavLink>
          </span>
        </li>
      </ul>
    </div>
  </nav>
);

export default Navbar;
